const fr = {
  brand: "E2 Care",
  tagline: "Soins calmes et connectés.",
  nav_dashboard: "Tableau de bord",
  nav_residents: "Patients",
  nav_patients: "Patients",
  nav_rooms: "Chambres",
  nav_devices: "Appareils",
  nav_events: "Événements",
  nav_alerts: "Alertes",
  nav_users: "Équipe",
  nav_settings: "Paramètres",
  nav_admin: "Administration",
  nav_signout: "Se déconnecter",
  topbar_search_placeholder: "Rechercher patients, chambres, appareils…",
  admin_super_only: "Seuls les super-administrateurs peuvent gérer les organisations.",
  admin_admin_only: "Seuls les administrateurs peuvent accéder à cette page.",
  admin_tab_orgs: "Organisations",
  admin_tab_users: "Utilisateurs",
  admin_tab_patients: "Patients",
  admin_tab_rooms: "Chambres",
  admin_tab_buildings: "Bâtiments",
  admin_tab_devices: "Appareils",
  admin_tab_alerts: "Alertes",
  admin_tab_qa: "Outils de test",
  admin_delete: "Supprimer",
  admin_no_orgs_yet: "Aucune organisation pour le moment.",
  admin_field_name: "Nom",
  admin_field_email: "E-mail",
  admin_field_phone: "Téléphone",
  admin_field_password: "Mot de passe",
  admin_field_role: "Rôle",
  admin_field_type: "Type",
  admin_field_timezone: "Fuseau horaire",
  admin_field_address: "Adresse",
  admin_field_status: "Statut",
  admin_field_organization: "Organisation",
  admin_password_keep: "Laisser vide pour conserver",
  admin_field_birth_date: "Date de naissance",
  admin_field_room: "Chambre",
  admin_field_room_none: "Non assigné",
  admin_field_photo: "URL de la photo",
  admin_field_photo_hint: "Collez une URL publique — téléversement complet en v2.",
  admin_field_notes: "Notes du soignant",
  admin_field_emergency_contact: "Contact d’urgence principal",
  admin_field_ec_name: "Nom",
  admin_field_ec_phone: "Téléphone",
  admin_field_ec_relationship: "Lien",
  admin_field_mac: "Adresse MAC",
  admin_field_firmware: "Micrologiciel",
  admin_field_assignment: "Affecté à",
  admin_field_assigned_room: "Chambre affectée",
  admin_field_assigned_patient: "Patient affecté",
  admin_field_assigned_hint: "Facultatif. Capteurs → chambre ; bracelets → patient.",
  admin_field_sensor_target: "Monté sur",
  admin_field_sensor_target_hint: "Indique au système si ce capteur surveille une porte ou une fenêtre.",
  sensor_target_door: "Porte",
  sensor_target_window: "Fenêtre",
  sensor_target_unset: "Non configuré",
  admin_field_sensor_label: "Nom du capteur",
  admin_field_sensor_label_hint: "Nom convivial affiché dans les alertes et les événements — p. ex. « Porte d’entrée », « Fenêtre de la salle de bain ».",
  admin_field_building: "Bâtiment",
  admin_field_building_required: "Une chambre doit appartenir à un bâtiment.",
  room_openings: "Ouvertures",
  room_no_openings: "Aucun capteur de porte ou de fenêtre installé dans cette chambre.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Dernier changement",
  admin_field_description: "Description",
  admin_field_severity: "Gravité",
  admin_field_patient: "Patient",
  admin_field_device: "Appareil",
  admin_field_message: "Message",
  admin_orgs_title: "Organisations",
  admin_orgs_sub: "Créer, modifier et archiver les locataires d’E2 Care.",
  admin_orgs_count: "organisations",
  admin_org_new: "Nouvelle organisation",
  admin_org_new_title: "Nouvelle organisation",
  admin_org_edit_title: "Modifier l’organisation",
  admin_org_created: "Organisation créée.",
  admin_org_updated: "Organisation mise à jour.",
  admin_org_deleted: "Organisation archivée.",
  admin_org_delete_title: "Archiver l’organisation ?",
  admin_org_delete_confirm: "« {name} » sera masquée des listes.",
  admin_users_title: "Utilisateurs",
  admin_users_sub_super: "Gérer chaque compte utilisateur sur tous les locataires.",
  admin_users_sub_org: "Gérer les comptes utilisateurs de {org}.",
  admin_user_new: "Nouvel utilisateur",
  admin_user_new_title: "Nouvel utilisateur",
  admin_user_edit_title: "Modifier l’utilisateur",
  admin_user_created: "Utilisateur créé.",
  admin_user_updated: "Utilisateur mis à jour.",
  admin_user_deleted: "Utilisateur archivé.",
  admin_user_delete_title: "Archiver l’utilisateur ?",
  admin_user_delete_confirm: "« {name} » perdra l’accès.",
  admin_user_memberships: "Adhésions aux organisations",
  admin_patients_title: "Patients",
  admin_patients_sub_super: "Gérer tous les dossiers patients sur tous les locataires.",
  admin_patients_sub_org: "Gérer les dossiers patients dans {org}.",
  admin_patient_new: "Nouveau patient",
  admin_patient_new_title: "Nouveau patient",
  admin_patient_edit_title: "Modifier le patient",
  admin_patient_created: "Patient créé.",
  admin_patient_updated: "Patient mis à jour.",
  admin_patient_deleted: "Patient archivé.",
  admin_patient_delete_title: "Archiver le patient ?",
  admin_patient_delete_confirm: "« {name} » sera masqué des listes.",
  admin_rooms_title: "Chambres",
  admin_rooms_sub_super: "Configurer les chambres sur tous les locataires.",
  admin_rooms_sub_org: "Configurer les chambres dans {org}.",
  admin_room_new: "Nouvelle chambre",
  admin_room_new_title: "Nouvelle chambre",
  admin_room_edit_title: "Modifier la chambre",
  admin_room_created: "Chambre créée.",
  admin_room_updated: "Chambre mise à jour.",
  admin_room_deleted: "Chambre archivée.",
  admin_room_delete_title: "Archiver la chambre ?",
  admin_room_delete_confirm: "« {name} » sera masquée.",
  admin_devices_title: "Appareils",
  admin_devices_sub_super: "Provisionner les appareils Moko sur tous les locataires.",
  admin_devices_sub_org: "Provisionner les appareils Moko dans {org}.",
  admin_device_new: "Nouvel appareil",
  admin_device_new_title: "Nouvel appareil",
  admin_device_edit_title: "Modifier l’appareil",
  admin_device_created: "Appareil créé.",
  admin_device_updated: "Appareil mis à jour.",
  admin_device_deleted: "Appareil archivé.",
  admin_device_delete_title: "Archiver l’appareil ?",
  admin_device_delete_confirm: "L’appareil {mac} sera masqué.",
  admin_buildings_title: "Bâtiments",
  admin_buildings_sub_super: "Regrouper les chambres par bâtiment / aile sur tous les locataires.",
  admin_buildings_sub_org: "Regrouper les chambres par bâtiment / aile dans {org}.",
  admin_building_new: "Nouveau bâtiment",
  admin_building_new_title: "Nouveau bâtiment",
  admin_building_edit_title: "Modifier le bâtiment",
  admin_building_created: "Bâtiment créé.",
  admin_building_updated: "Bâtiment mis à jour.",
  admin_building_deleted: "Bâtiment archivé.",
  admin_building_delete_title: "Archiver le bâtiment ?",
  admin_building_delete_confirm: "« {name} » sera masqué.",
  admin_qa_title: "Outils de test",
  admin_qa_sub: "Injecter événements / alertes pour tester sans matériel Moko réel.",
  admin_qa_event_title: "Injecter un événement test",
  admin_qa_event_sub: "Simule un webhook Moko.",
  admin_qa_alert_title: "Injecter une alerte test",
  admin_qa_alert_sub: "Saute la couche événement et écrit une alerte directement.",
  admin_qa_inject_event: "Injecter un événement",
  admin_qa_inject_alert: "Injecter une alerte",
  admin_qa_event_done: "Événement injecté.",
  admin_qa_alert_done: "Alerte injectée.",
  admin_qa_disclaimer: "Ces endpoints doivent être désactivés en production.",
  admin_alerts_title: "Politique d’alertes",
  admin_alerts_sub: "Règles d’alerte pour l’ensemble de {org}. Appliquées à chaque patient de ce locataire.",
  admin_alerts_quiet_title: "Heures calmes",
  admin_alerts_quiet_desc: "Définissez quand cette organisation est en « mode nuit ». Utile pour acheminer les alertes non critiques plus discrètement.",
  admin_alerts_quiet_hint: "Les heures sont interprétées dans le fuseau horaire local de l’organisation. La plage peut passer minuit (p. ex. 22:00 → 06:00).",
  admin_alerts_night_start: "Début de nuit",
  admin_alerts_night_end: "Fin de nuit",
  admin_alerts_load_failed: "Charger la politique d’alertes",
  admin_alerts_save_failed: "Enregistrer la politique d’alertes",
  admin_alerts_saved: "Politique d’alertes enregistrée.",
  admin_alerts_clear_title: "Effacer les alertes actives",
  admin_alerts_clear_desc: "Accusez réception de toutes les alertes ouvertes de cette organisation en un clic.",
  admin_alerts_clear_hint: "Utile après un exercice planifié ou un capteur mal configuré ayant produit une vague de faux positifs. Les alertes acquittées restent dans l’historique.",
  admin_alerts_ack_all_button: "Tout acquitter",
  admin_alerts_ack_all_title: "Acquitter toutes les alertes actives ?",
  admin_alerts_ack_all_confirm: "Cela marquera comme acquittée chaque alerte ouverte dans {org}. Cette action est irréversible.",
  admin_alerts_ack_all_done: "{count} alerte(s) acquittée(s).",
  admin_alerts_ack_all_done_generic: "Toutes les alertes actives ont été acquittées.",
  admin_alerts_ack_all_failed: "Acquitter toutes les alertes",
  org_type_nursing_home: "Maison de retraite",
  org_type_assisted_living: "Résidence assistée",
  org_type_hospital: "Hôpital",
  org_type_home_care: "Soins à domicile",
  role_admin: "Administrateur",
  role_caregiver: "Soignant",
  role_family: "Famille",
  status_active: "actif",
  status_inactive: "inactif",
  confirm: "Confirmer",
  sign_in: "Se connecter",
  sign_up: "S’inscrire",
  email: "E-mail",
  password: "Mot de passe",
  full_name: "Nom complet",
  create_account: "Créer un compte",
  no_account: "Pas encore de compte ?",
  have_account: "Vous avez déjà un compte ?",
  login_welcome: "Bon retour",
  login_sub: "Connectez-vous pour continuer à surveiller vos résidents.",
  register_welcome: "Rejoignez E2 Care",
  register_sub: "Créez votre espace de travail en moins d’une minute.",
  total_residents: "Patients",
  active_devices: "Appareils actifs",
  open_alerts: "Alertes ouvertes",
  offline_gateways: "Appareils hors ligne",
  falls_7d: "Chutes (7j)",
  sos_7d: "SOS (7j)",
  low_battery: "Batterie faible",
  critical_residents: "Critiques",
  status_ok: "Tout va bien",
  status_warning: "Attention",
  status_critical: "Critique",
  status_online: "En ligne",
  status_offline: "Hors ligne",
  search: "Rechercher",
  filter: "Filtrer",
  all: "Tous",
  refresh: "Actualiser",
  loading: "Chargement…",
  no_results: "Rien pour le moment.",
  view_profile: "Voir le profil",
  showing_n_of_m: "Affichage de {n} sur {m}",
  load_more: "Charger plus",
  auto_refresh: "En direct · auto-actualisation",
  auto_refresh_paused: "En pause (charger plus actif)",
  updated_just_now: "Mis à jour à l’instant",
  updated_n_sec_ago: "Mis à jour il y a {n}s",
  updated_n_min_ago: "Mis à jour il y a {n}m",
  acknowledge: "Acquitter",
  acknowledged: "Acquitté",
  ack_all: "Tout acquitter",
  ack_all_confirm: "Acquitter les {count} alerte(s) active(s) ?",
  ack_all_running: "Acquittement…",
  ack_all_done: "{count} alerte(s) acquittée(s).",
  ack_all_partial: "{ok} acquittée(s) · {fail} échec(s).",
  last_seen: "Vu pour la dernière fois",
  battery: "Batterie",
  signal: "Signal",
  firmware: "Micrologiciel",
  room: "Apt / Chambre",
  age: "Âge",
  emergency_contact: "Contact d’urgence",
  notes: "Notes",
  assigned_devices: "Appareils affectés",
  recent_events: "Événements récents",
  timeline_24h: "Dernières 24 heures",
  delivery_status: "Statut de livraison",
  acknowledged_by: "Acquitté par",
  dashboard_title: "Aperçu",
  dashboard_sub: "Un aperçu rapide de tout ce qui se passe dans vos résidences.",
  residents_title: "Patients",
  residents_sub: "Les personnes que vous surveillez actuellement.",
  devices_title: "Appareils",
  devices_sub: "Capteurs et bracelets.",
  devices_sub_admin: "Passerelles, capteurs et bracelets.",
  events_title: "Événements en direct",
  events_sub: "Flux chronologique de chaque appareil connecté.",
  alerts_title: "Alertes",
  alerts_sub: "Notifications escaladées à la famille et aux soignants.",
  settings_title: "Paramètres",
  settings_sub: "Vos préférences et règles de notification.",
  users_title: "Équipe",
  users_sub: "Soignants, famille et administrateurs ayant accès.",
  falls_chart_title: "Chutes & SOS — 7 derniers jours",
  recent_alerts_title: "Alertes critiques récentes",
  no_alerts: "Aucune alerte ouverte. Tout le monde est en sécurité.",
  event_fall: "Chute détectée",
  event_sos: "Bouton SOS pressé",
  event_door_open: "Porte ouverte",
  event_door_close: "Porte fermée",
  event_inactivity: "Inactivité prolongée",
  event_low_battery: "Batterie faible",
  event_offline: "Appareil hors ligne",
  event_online: "Appareil de retour en ligne",
  event_heartbeat: "Battement",
  event_button_press: "Bouton pressé",
  device_gateway: "Passerelle Bluetooth",
  device_door_sensor: "Capteur de porte",
  device_bracelet: "Bracelet",
  device_unknown: "Appareil inconnu",
  language: "Langue",
  notifications: "Notifications",
  quiet_hours: "Heures calmes",
  escalation: "Politique d’escalade",
  just_now: "à l’instant",
  min_ago: "min",
  h_ago: "h",
  d_ago: "j",
  demo_hint: "Compte démo : admin@e2care.lv / Care2024!",
  open_menu: "Ouvrir le menu",
  close_menu: "Fermer le menu",
  care_team: "Équipe soignante",
  family_members: "Famille",
  no_caregivers: "Aucun soignant assigné pour le moment.",
  no_family: "Aucun membre de la famille lié pour le moment.",
  add_caregiver: "Ajouter un soignant",
  add_family: "Ajouter un membre de la famille",
  select_user: "Sélectionnez un utilisateur…",
  cancel: "Annuler",
  add: "Ajouter",
  remove: "Retirer",
  save: "Enregistrer",
  relationship: "Lien de parenté",
  relationship_son: "Fils",
  relationship_daughter: "Fille",
  relationship_spouse: "Conjoint",
  relationship_other: "Autre",
  notify_via: "Notifier via",
  call_contact: "Appeler",
  view_resident: "Ouvrir le profil",
  address: "Adresse",
  admin_only_section: "Outils admin",
  rooms_title: "Chambres",
  rooms_sub: "Chaque chambre supervisée — patients, appareils et état actuel.",
  room_name: "Chambre",
  room_type: "Type",
  room_type_private_room: "Chambre privée",
  room_type_shared_room: "Chambre partagée",
  room_type_apartment: "Appartement",
  room_type_corridor: "Couloir",
  room_type_common_area: "Espace commun",
  room_floor: "Étage",
  room_state: "État actuel",
  door: "Porte",
  window: "Fenêtre",
  door_open_state: "Ouverte",
  door_closed_state: "Fermée",
  door_unknown_state: "Inconnue",
  room_no_devices: "Aucun appareil dans cette chambre pour le moment.",
  room_no_patients: "Aucun patient affecté à cette chambre pour le moment.",
  room_patients: "Patients dans la chambre",
  room_devices: "Appareils dans la chambre",
  room_activity: "Chronologie d’activité",
  rooms_filter_all_types: "Tous les types",
  widget_active_alerts: "Alertes actives",
  widget_active_alerts_sub: "Critiques, non résolues et acquittées",
  widget_patients_status: "État des patients",
  widget_devices_health: "État des appareils",
  widget_room_activity: "Activité des chambres",
  widget_recent_events: "Flux d’événements en direct",
  widget_connectivity: "Connectivité",
  metric_critical: "Critique",
  metric_unresolved: "Non résolu",
  metric_acknowledged_count: "Acquittés",
  metric_total: "Total",
  metric_active: "Actifs",
  metric_online: "En ligne",
  metric_offline: "Hors ligne",
  metric_ota_pending: "OTA en attente",
  metric_battery_warn: "Batterie faible",
  metric_doors_open: "Portes ouvertes",
  metric_windows_open: "Fenêtres ouvertes",
  metric_signal_avg: "Signal moyen",
  metric_last_comm: "Dernière comm",
  metric_packets: "Paquets / h",
  view_all: "Voir tout",
  status_new: "Nouveau",
  status_acknowledged: "Acquitté",
  status_resolved: "Résolu",
  status_resolved_local: "Résolu (local)",
  resolve: "Résoudre",
  add_note: "Ajouter une note",
  save_note: "Enregistrer la note",
  resolve_local_badge: "cet appareil uniquement",
  resolve_local_hint: "Marque l’alerte comme résolue uniquement dans votre navigateur. Le serveur et les autres membres de l’équipe la voient toujours comme ouverte.",
  note_placeholder: "Ajoutez du contexte pour l’équipe…",
  notes_count: "{n} note(s)",
  device_detail: "Détail de l’appareil",
  device_diagnostics: "Diagnostics",
  device_firmware_history: "Historique du micrologiciel",
  device_ota_config: "Configuration OTA",
  device_ota_status: "Statut OTA",
  device_signal: "Qualité du signal",
  device_mac: "Adresse MAC",
  device_serial: "Numéro de série",
  fall_sensitivity: "Sensibilité aux chutes",
  transmission_interval: "Intervalle de transmission",
  low_battery_threshold: "Seuil de batterie faible",
  ota_idle: "Inactif",
  ota_pending: "En attente",
  ota_deploying: "Déploiement",
  ota_failed: "Échec",
  events_filter_severity: "Gravité",
  events_filter_room: "Chambre",
  events_filter_patient: "Patient",
  events_filter_device: "Appareil",
  severity_info: "Info",
  severity_warning: "Avertissement",
  severity_critical: "Critique",
  telegram_title: "Alertes Telegram",
  telegram_desc: "Recevez des alertes Telegram pour les résidents qui vous sont assignés.",
  telegram_connect: "Connecter Telegram",
  telegram_connected: "Telegram connecté",
  telegram_connected_as: "Connecté à Telegram en tant que {name}",
  telegram_connect_success: "Telegram connecté avec succès",
  telegram_connect_error: "Impossible de connecter Telegram. Veuillez réessayer.",
  telegram_missing_bot: "Bot Telegram non configuré. Définissez REACT_APP_TELEGRAM_BOT dans le fichier env.",
  telegram_disconnect: "Déconnecter",
  telegram_disconnect_success: "Telegram déconnecté.",
  telegram_disconnect_error: "Impossible de déconnecter Telegram. Veuillez réessayer.",
  telegram_already_linked: "Ce compte Telegram est déjà lié à un autre utilisateur e2-care.",
  telegram_switch_q: "Utiliser un autre compte Telegram ?",
  telegram_switch_intro: "Telegram mémorise le compte connecté sur tous les sites web. Pour en utiliser un autre :",
  telegram_switch_step1: "Ouvrez Telegram Web et déconnectez-vous de votre compte actuel.",
  telegram_switch_step2: "Revenez ici et rechargez le bouton ci-dessous, puis connectez-vous avec l’autre compte.",
  telegram_open_web: "Ouvrir Telegram Web",
  telegram_reload_widget: "Je me suis déconnecté — recharger le bouton",
  lang_autodetected_toast: "Langue détectée : {language}. Vous pouvez la changer dans les Paramètres.",
  admin_view_active: "Actifs",
  admin_view_archived: "Archivés",
  admin_restore: "Restaurer",
  admin_restored: "Restauré.",
  admin_hard_delete: "Supprimer définitivement",
  admin_hard_delete_title: "Supprimer définitivement ?",
  admin_hard_delete_confirm: "« {name} » sera définitivement supprimé de la base de données. Cette action est irréversible.",
  admin_hard_deleted: "Définitivement supprimé.",
  admin_no_archived: "Aucun élément archivé.",
  language_desc: "Utilisée pour l’interface de l’application et vos notifications Telegram + push.",
  language_saved: "Langue mise à jour.",
  language_error: "Impossible de mettre à jour la langue. Veuillez réessayer.",
  admin_field_language: "Langue",
  edit: "Modifier",
  generic_error: "Une erreur s’est produite. Veuillez réessayer.",
  caregiver_added: "Soignant ajouté.",
  caregiver_removed: "Soignant retiré.",
  family_added: "Membre de la famille ajouté.",
  family_removed: "Membre de la famille retiré.",
  menu: "Menu",
  dl_companion_app: "Application compagnon",
  dl_hero_title: "E2 Care pour Android",
  dl_hero_sub: "Installez l’application compagnon sur un téléphone équipé Moko pour relayer les alertes, configurer les appareils et rester connecté à votre équipe de soins — même lorsque le tableau de bord est fermé.",
  dl_android_apk: "APK Android",
  dl_version_loading: "chargement de la version…",
  dl_released: "Publié le {date}",
  dl_download_apk: "Télécharger l’APK",
  dl_unavailable: "Indisponible",
  dl_preparing: "Préparation…",
  dl_manifest_error: "Impossible de charger le manifeste. Essayez d’actualiser — si le problème persiste, le serveur de build est peut-être en cours de redéploiement.",
  dl_whats_new: "Nouveautés",
  dl_installing_title: "Installation sur votre téléphone",
  dl_step1: "Appuyez sur « Télécharger l’APK » ci-dessus. Votre navigateur peut avertir que les fichiers APK peuvent endommager votre appareil — cet avertissement est normal pour tout installateur téléchargé hors du Play Store.",
  dl_step2: "Ouvrez le fichier téléchargé. Android vous demandera d’autoriser les installations depuis ce navigateur la première fois — activez l’autorisation, puis revenez.",
  dl_step3: "Appuyez sur « Installer », puis sur « Ouvrir » une fois terminé.",
  dl_step4: "Connectez-vous avec vos identifiants E2 Care.",
  dl_iphone_note: "La version iPhone arrivera plus tard. Pour l’instant, veuillez utiliser le tableau de bord web.",
  dl_back_to_dashboard: "Retour au tableau de bord",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Changer d’organisation efface l’affectation actuelle de chambre et de patient.",
  admin_view_full: "Liste complète",
  device_filter_assignment: "Affectation",
  device_filter_patient: "Affecté à un patient",
  device_filter_room: "Affecté à une chambre",
  device_filter_unassigned: "Non affecté",
  admin_all_orgs: "Toutes les organisations",
  pagination_prev: "Précédent",
  pagination_next: "Suivant",
  pagination_per_page: "Par page",
  pagination_page_of: "Page {page} sur {pages}",
  pagination_total: "{total} au total",
};
export default fr;
